import type { FormInstance }   from 'antd';
import dayjs                   from 'dayjs';
import React                   from 'react';
import { Form }                from 'antd';
import { Radio }               from 'antd';
import { Col }                 from 'antd';
import { DatePicker }          from 'antd';
import { TimePicker }          from 'antd';
import { Checkbox }            from 'antd';
import { observer }            from 'mobx-react';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import Input                   from 'components/App/IntlInput';
import RichTextEditor          from 'components/App/RichTextEditor';
import Row                     from 'components/App/Row';
import handleFormError         from 'utils/handleFormError';
import { ApiCollection }       from 'collections/ApiCollection';
import DemandTypeModel         from 'models/DemandTypeModel';
import {
  EXEMPTION_DELIVERY,
  EXEMPTION_DISMANTLING,
  EXEMPTION_MOUNTING,
}                              from 'constants/DemandTypes';
import DemandStatusModel       from 'models/DemandStatusModel';
import { IN_PROGRESS }         from 'constants/DemandStatuses';
import { AppFormComponent }    from 'components/App/AppForm';
import DemandConfigModel       from 'models/DemandConfigModel';
import StandModel              from 'models/StandModel';
import type { Dayjs }          from 'dayjs';
import DemandModel             from 'models/DemandModel';

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

interface DemandExemptionFormProps {
  demandConfigs: DemandConfigModel[];
  model: DemandModel;
  onSuccess?: (model: DemandModel) => void;
  stand: StandModel;
}

@observer
class DemandExemptionForm extends AppFormComponent<DemandExemptionFormProps> {
  public demandStatusCollection = new ApiCollection(DemandStatusModel);
  public demandTypeCollection = new ApiCollection(DemandTypeModel);

  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state = {
    demandTypeSelected: undefined,
  };

  public componentDidMount() {
    const { model } = this.props;

    this.setState({ demandTypeSelected: model.demandTypeIri });

    this.formRef.current?.setFieldsValue({
      askedDate: model.askedDatetime ? model.askedDatetimeDate : undefined,
      askedTime: model.askedDatetime ? model.askedDatetimeDate : undefined,
      // comment: model.comment, // only on post
      company: model.company,
      demandType: model.demandTypeIri,
      email: model.email,
      firstname: model.firstname,
      lastname: model.lastname,
      phone: model.phone,
    });

    this.demandStatusCollection.list();

    this.demandTypeCollection.setFilter('reference', [
      EXEMPTION_DELIVERY,
      EXEMPTION_MOUNTING,
      EXEMPTION_DISMANTLING,
    ]);
    this.demandTypeCollection.list();
  }

  public render() {
    const { demandConfigs, model } = this.props;

    const demandStatus = this.demandStatusCollection.findBy('id', model.demandStatusId) as DemandStatusModel;
    const demandStatusInProgress = !demandStatus || demandStatus.reference === IN_PROGRESS;

    const demandConfig = demandConfigs.find(
      dConfig => dConfig?.demandType === this.state.demandTypeSelected,
    );

    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <u>
              <FormattedMessageWrapper id="Coordonnées de la personne responsable du stand :" />
            </u>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('company') || ''}
              // validateStatus={getFieldError('company') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Société" />}
              labelCol={{ span: 24 }}
              name="company"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('lastname') || ''}
              // validateStatus={getFieldError('lastname') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="lastname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('firstname') || ''}
              // validateStatus={getFieldError('firstname') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Prénom" />}
              labelCol={{ span: 24 }}
              name="firstname"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('phone') || ''}
              // validateStatus={getFieldError('phone') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Téléphone" />}
              labelCol={{ span: 24 }}
              name="phone"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('email') || ''}
              // validateStatus={getFieldError('email') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Email" />}
              labelCol={{ span: 24 }}
              name="email"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormattedMessageWrapper id="Afin de faciliter votre demande merci de remplir ce formulaire." />
            <br />
            <FormattedMessageWrapper id="En fonction des indications données notre service vous contactera pour modifier ou valider votre demande." />
          </Col>
          <Col span={24}>
            <Form.Item
              // help={getFieldError('demandType') || ''}
              // validateStatus={getFieldError('demandType') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Votre demande concerne une demande de" />}
              labelCol={{ span: 24 }}
              name="demandType"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Radio.Group
                disabled={!!model.id}
                onChange={event => this.setState({ demandTypeSelected: event.target.value })}
              >
                {demandConfigs.map(dConfig => {
                  const dTypeFound = this.demandTypeCollection.findBy('@id', dConfig?.demandType) as DemandTypeModel;
                  if (!dTypeFound) {
                    return <React.Fragment key={dConfig?.id} />;
                  }

                  return (
                    <Radio key={dTypeFound.id} style={radioStyle} value={dTypeFound.get('@id')}>
                      <FormattedMessageWrapper id={dTypeFound.label} />
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('askedDate') || ''}
              // validateStatus={getFieldError('askedDate') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Date souhaitée" />}
              labelCol={{ span: 24 }}
              name="askedDate"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <DatePicker
                disabled={!demandStatusInProgress}
                disabledDate={current => this.isDateDisabled(current, demandConfig)}
                format="DD/MM/YYYY"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              // help={getFieldError('askedTime') || ''}
              // validateStatus={getFieldError('askedTime') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Heure souhaitée" />}
              labelCol={{ span: 24 }}
              name="askedTime"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <TimePicker
                disabled={!demandStatusInProgress}
                format="HH[h]mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>

        {!model.id && (
          <>
            <Row>
              <Col span={24}>
                <Form.Item
                  // help={getFieldError('comment') || ''}
                  // validateStatus={getFieldError('comment') ? 'error' : ''}
                  label={<FormattedMessageWrapper id="Commentaire" />}
                  labelCol={{ span: 24 }}
                  name="comment"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item
                  // help={getFieldError('confirmation') || ''}
                  // validateStatus={getFieldError('confirmation') ? 'error' : ''}
                  name="confirmation"
                  rules={[
                    () => ({
                      message: <FormattedMessageWrapper id="Confirmation manquante" />,
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject();
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col span={20}>
                <FormattedMessageWrapper id="J'ai bien pris en compte que cette demande ne donne droit à aucune dérogation sans l'acceptation de la part de nos équipes. Une réponse vous sera adressée prochainement." />
              </Col>
            </Row>
          </>
        )}
      </Form>
    );
  }

  public submit = async () => {
    const { model, onSuccess, stand } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      await model.patch({
        askedDatetime: dayjs(
          `${values.askedDate.format('YYYY-MM-DD')} ${values.askedTime.format('HH:mm')}`,
        ).utc().format('YYYY-MM-DD HH:mm'),
        comment: values.comment ? values.comment : undefined,
        company: values.company,
        demandType: values.demandType,
        email: values.email,
        firstname: values.firstname,
        lastname: values.lastname,
        phone: values.phone,
        stand: stand.get('@id'),
      });

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private isDateDisabled = (date: Dayjs, demandConfig?: DemandConfigModel) => {
    if (!demandConfig) {
      return true;
    }

    let isAfter = false;
    if (demandConfig.demandsAfterDate && demandConfig.demandsAfterDate.isAfter(date, 'day')) {
      isAfter = true;
    }

    let isBefore = false;
    if (demandConfig.demandsBeforeDate && demandConfig.demandsBeforeDate.isBefore(date, 'day')) {
      isBefore = true;
    }

    return isAfter || isBefore;
  };
}

export default DemandExemptionForm;
